import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

const GAUGE_WIDTH = '311px';

export const StyledNetSentimentScore = styled('div')(
  () => css`
    &.net-sentiment-score {
      gap: 24px;
      align-items: stretch;

      .nss-gauge-card {
        flex: 0 0 ${GAUGE_WIDTH};
        max-width: ${GAUGE_WIDTH};
      }

      .nss-trend-card {
        flex: 1;
        min-width: 0;
      }

      @media (max-width: 1024px) {
        flex-direction: column;

        .nss-gauge-card {
          flex: 1 1 auto;
          max-width: none;
        }
      }
    }
  `
);
